import HomeScreenCard from "../HomeScreenCard";
import { ZodiacalPrognosisStatus } from "../../types/ZodiacalPrognosisStatus";
import CardStatusBar from "../CardStatusBar";
import HomeCardTitle from "../HomeCardTitle";
import zodiacBackground from "@/assets/img/d_stars_background_3.png";
import zodiacCircle from "@/assets/img/d_zodiac_circle.png";

interface ZodiaPrognoseCardProps {
  navigateToZodiacPrognosis: () => void;
  zodiacalPrognosisStatus: ZodiacalPrognosisStatus | null;
  gridColumn: string;
  gridRow: string;
}

export const ZodiaPrognoseCard = ({
  navigateToZodiacPrognosis,
  zodiacalPrognosisStatus,
  gridColumn,
  gridRow,
}: ZodiaPrognoseCardProps) => (
  <HomeScreenCard
    gridColumn={gridColumn}
    gridRow={gridRow}
    bgStyle={{
      background: `url(${zodiacBackground}) center/cover`,
      position: "relative",
    }}
    overlayImage={zodiacCircle}
    overlayImageStyle={{
      top: "0%",
      left: "0%",
      width: "100%",
      height: "auto",
    }}
    onClick={() => navigateToZodiacPrognosis()}
    style={{ cursor: "pointer", paddingBottom: "20px" }}
    statusBar={
      zodiacalPrognosisStatus?.isSubscribed && (
        <CardStatusBar
          text={zodiacalPrognosisStatus?.timeToNextCard || "Доступно"}
          isAvailable={zodiacalPrognosisStatus?.isAvailable || false}
        />
      )
    }
  >
    <div
      className={`p-2 sm:p-3 md:p-4 flex flex-col absolute bottom-0 justify-end `}
      style={{ zIndex: 20, cursor: "pointer" }}
    >
      
      <HomeCardTitle
        isNeedShort={false}
        title="Зодиакальный прогноз на неделю"
        description="Это усреднённый вектор, который задаёт «характер недели» для представителей вашего знака."
      />
    </div>
  </HomeScreenCard>
);
